import { ColorInput } from "../ColorInput/ColorInput";
import { useColorInput } from "../../Color/ColorCodes/ColorInfoCard/ColorInput/useColorInput";
import type { SelectedColor } from "store/features/colorPicker/types";
import { translateFunc } from "client/utils/translateFunc";

export interface BackgroundColorInputProps {
    selectedColor: SelectedColor;
}

export const BackgroundColorInput = ({ selectedColor }: BackgroundColorInputProps) => {
    const { value, onChange } = useColorInput({
        color: selectedColor,
        colorFormat: "hex",
        setShowInput: () => {},
        setColorError: () => {},
    });
    return <ColorInput label={translateFunc("background-color")} value={value} onChange={onChange} />;
};
